import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTAddOrderToReturnAllowListThenSendMacro from '../NodeGroups/DTCopyTextSendMacro/DTAddOrderToReturnAllowListThenSendMacro/DTAddOrderToReturnAllowListThenSendMacro';

const AddOrderToReturnAllowlistThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTAddOrderToReturnAllowListThenSendMacro
      showConfirmation={showConfirmationPage}
      message={'Order has been added to the allow list for return.'}
    />
  );
};

export default AddOrderToReturnAllowlistThenSendMacro;
